export default {
  TODO: {
    Title: 'To-Do',
    Color: '#FFE0CC',
  },
  IN_PROGRESS: {
    Title: 'In Progress',
    Color: '#cff5d1',
  },
  DONE: {
    Title: 'Done',
    Color: '#c1f5f0',
  },
  WON: {
    Title: 'Won',
    Color: '#c1f5f0',
  },
  REJECTED: {
    Title: 'Rejected',
    Color: '#616670',
  },
  CHURNED: {
    Title: 'Churned',
    Color: '#616670',
  },
  CLOSED_LOST: {
    Title: 'Closed Lost',
    Color: '#d1e2ff',
  },
};
